import React, { ReactNode } from 'react';
import Title from '../Title';
import Text from '../Text';
import './InfoItem.less';
import Wrapper from '../Wrapper';

export type InfoItemProps = {
  lable?: ReactNode;
  content?: ReactNode;
  lableSize?: 1 | 2 | 3 | 4;
  lableColor?: 'dark-20';
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  width?: 'maxContent';
  fallBack?: string | ReactNode;
};

const InfoItem: React.FC<InfoItemProps> = ({
  lable,
  content,
  onClick = () => {},
  lableSize = 3,
  lableColor = 'dark-20',
  width,
  fallBack = 'No Data',
}) => {
  const classNames = ['t-info-item'];
  if (width === 'maxContent') {
    classNames.push('t-max-content-info-item');
  }
  return (
    <div>
      <Wrapper pl={1} pb={3}>
        <Text rows={1} textColor={lableColor} level={lableSize}>
          {lable}
        </Text>
      </Wrapper>
      <div onClick={onClick} className={classNames.join(' ')}>
        {!!content ? (
          content
        ) : (
          <Text textColor="dark-50" level={2}>
            {fallBack}
          </Text>
        )}
      </div>
    </div>
  );
};

export default InfoItem;
